import { atom } from 'jotai'

export enum MenuKeys {
  Trade = 1,
  Community,
  More,
  Account,
  Network,
  Notification,
}

export const menuAtom = atom<MenuKeys | 0>(0)

export enum SecondMenuKeys {
  Spot = 1,
  Perp,
}
export const secondMenuAtom = atom<SecondMenuKeys | 0>(SecondMenuKeys.Spot)

export const mobileMenuAtom = atom<boolean>(false)
